import * as $ from 'jquery';
import { UtilsString } from '@/utils/utils-string';

export class BaseDto { 

    public id: any = null;
    public createdby!:number;
    public updatedby!:number;
    public datecreated!:Date;
    public dateupdated!:Date;
    public id_cliente!:number;
    public Version!: any;
    private originalJson: string = UtilsString.Empty;

    constructor(src?: any, enableTrackChanges: boolean = false) {
        this.copy(src);

        if (enableTrackChanges) {
            this.resetTrackChanges();
        }
    }

    public copy(src?: any) {
        if (src) {
            $.extend(this, src);
        }
    }

    public isNewItem(): boolean {
        return this.id === null ? true : false;
    }

    public isChanged(): boolean {
        if (this.originalJson != null) {
            const currentJson = JSON.stringify(this.omitKeys(this, ['originalJson']));
            return currentJson !== this.originalJson;
        } else {
            return false;
        }
    }

    public fromJson(data: string) {
        if (data) {
            const object = JSON.parse(data);
            $.extend(this, object);
        }
    }

    public toJson(omitProperties: string[] = [], resetTrackChanges: boolean = true) {
        omitProperties.push('originalJson');
        if (omitProperties.indexOf('id') === -1 && (this.id === null || this.id === undefined)) {
            omitProperties.push('id');
        }
        const jsonData = JSON.stringify(this.omitKeys(this, omitProperties));

        if (resetTrackChanges) {
            this.originalJson = jsonData;
        }

        return jsonData;
    }

    protected resetTrackChanges() {
        this.toJson();
    }

    private omitKeys(obj: any, keys: any) {
        const dup: any = {};
        for (const key in obj) {
            if (keys.indexOf(key) === -1) {
                dup[key] = obj[key];
            }
        }
        return dup;
    }
}
